import { getAppStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { ServerUrls } from '../../app/ServerUrls';
import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { IError } from '../../httpClient/serverApi/types/IError';
import { ISchedule } from '../../schedule/types/ISchedule';
import { serverScheduleUrl, siteScheduleUrl } from '../../schedule/utils/ScheduleUtils';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { SchedulingErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';

export namespace ScheduleErrorsService {
  export function errorDetailsFor(scheduleErrorItem: IErrorItem<ISchedule>): IErrorDetail {
    return {
      itemName: scheduleErrorItem.item.name,
      itemUrl:
        scheduleErrorItem.error.code === SchedulingErrorCode.SchedulingScheduleNotFound
          ? null
          : ScheduleErrorsService.scheduleUrl(scheduleErrorItem.item),
      errorMessage: ScheduleErrorsService.errorMessageForItem(scheduleErrorItem)
    };
  }

  export function scheduleUrl(schedule: ISchedule): string {
    return getSessionManagementServiceInstance().sessionSiteId()
      ? ScheduleErrorsService.siteUrl(schedule)
      : ScheduleErrorsService.serverUrl(schedule);
  }

  export function siteUrl(schedule: ISchedule): string {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteScheduleUrl(siteUrls, schedule.id, schedule.scheduledAction);
  }

  export function serverUrl(schedule: ISchedule): string {
    return serverScheduleUrl(ServerUrls.getInstance(), schedule.id, schedule.scheduledAction);
  }

  export function errorMessageForItem(errorItem: IErrorItem<ISchedule>) {
    return ScheduleErrorsService.errorMessageFor(errorItem.error, errorItem.item.name);
  }

  export function errorMessageFor(error: IError, scheduleName: string = '') {
    switch (error.code) {
      case SchedulingErrorCode.SchedulingScheduleNotFound:
        return Messages.errorScheduleNotFound({ SCHEDULE_NAME: L10n.elideIfLong(scheduleName) });
      case SchedulingErrorCode.SchedulingNameAlreadyExists:
        return Messages.errorScheduleNameAlreadyExists();
      case SchedulingErrorCode.SchedulingNameTooLong:
        return Messages.errorScheduleNameTooLong();
      default:
        return Messages.errorUnknown();
    }
  }
}
